import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { FormFeedback, Input, FormGroup, Button } from "reactstrap";
import { checkValidations } from "../../../utils/checkValidations";
import { validationMessage } from "../../../utils/validation";

const PasswordBox = React.forwardRef(
	(
		{
			showPassword,
			name,
			placeholder,
			isRequired = true,
			edit = true,
			max = 100,
			handleVal,
			isIcon = false,
			isLocked = true,
			className = "",
			label = "",
			id = "id",
			labelLink = false,
			handleKeypress,
			value,
			autoComplete = "off",
			togglePassword = null
		},
		ref
	) => {
		const [password, setPassword] = useState({ value: value, isValid: false });

		const getPassword = (name, value) => {
			const val = value.replace(/\s+/g, " ").trim();
			checkValidations(name, val)
				? setPassword({ value: value, isValid: false })
				: setPassword({ value: value, isValid: true });
			handleVal(value);
		};

		return (
			<>
				{/* <label htmlFor="password">{Name}</label>
      {isRequired && <span style={{ 'color': '#ff0000' }}>  *</span>} */}

				<FormGroup className={`input-wrapper ${className}`}>
					<label htmlFor={id}>
						{label}
					</label>
					<div className={`input-cell position-relative ${isIcon ? 'input-icon' : ''}`}>
						<Input
							ref={ref}
							id={id}
							placeholder={placeholder}
							name="password"
							value={password.value}
							type={showPassword ? "text" : "password"}
							maxLength={max + 1}
							disabled={!edit}
							required
							autoComplete={autoComplete}
							invalid={
								Boolean(isRequired && password && password.isValid) ||
								!isLocked ||
								Boolean(password && password.value && password.value.length > max)
							}
							onKeyDown={(e) => e.keyCode === 13 && handleKeypress(e)}
							onChange={($event) => {
								getPassword(
									"password",
									typeof $event === "string" ? $event : $event.target.value
								);
							}}
						/>
						{isIcon &&
							<Button
								type='button'
								color="link"
								className="position-absolute right-side-icon p-0"
								onClick={togglePassword}>
								{showPassword === false ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
							</Button>
						}
					</div>

					{!password.value ? (
						<FormFeedback
							className={
								(password.isValid && !password.value) || !isLocked
									? "customerror"
									: ""
							}
						>
							{validationMessage["passwordReq"]}
						</FormFeedback>
					) : (
						""
					)}
					{password.value && password.value.length ? (
						<FormFeedback
							className={
								password.isValid && password.value.length ? "customerror" : ""
							}
						>
							{validationMessage["passLength"]}
						</FormFeedback>
					) : (
						""
					)}
					{password && password.value && password.value.length > max ? (
						<FormFeedback
							className={
								password && password.value && password.value.length > max
									? "customerror"
									: ""
							}
						>
							{validationMessage["textMaxInvalid"](max)}
						</FormFeedback>
					) : (
						""
					)}
				</FormGroup>
			</>
		);
	}
);
export default PasswordBox;
